export const WELCOME_VIDEO_TITLE = 'Welcome to SWYMO!';
export const WELCOME_VIDEO_URL =
  'https://player.vimeo.com/video/887460124?h=78509964df?title=0&portrait=0&byline=0&pip=0&transcript=0';
